/**
 * @file AgendaAttendant class is a wrapper of PlanItem from the backend api towards the Agenda.
 * @author Wim Haanstra
 */
import * as tslib_1 from "tslib";
import { PlanItemWrapper } from './plan-item-wrapper';
import * as moment from 'moment';
/** AgendaAttendant class is a wrapper of the PlanItem entity containing an Availability entity. */
var AgendaAttendant = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaAttendant, _super);
    /**
     * Constructs a AgendaAvailability.
     * @param item The PlanItem being wrapped.
     */
    function AgendaAttendant(item) {
        return _super.call(this, item) || this;
    }
    /**
     * Initialize wrapper properties
     * @protected
     * @memberOf PlanItemWrapper
     */
    AgendaAttendant.prototype.initialize = function () {
        this.entity = this.item.Item;
        var start = this.item.Start;
        var finish = this.item.Finish;
        if (this.entity && this.entity.entityType.shortName === 'Service') {
            start = this.entity['StartBase'];
            finish = this.entity['FinishBase'];
        }
        this.startHour = moment(start).hours();
        this.startMinute = moment(start).minutes();
        this.endHour = moment(finish).hours();
        this.endMinute = moment(finish).minutes();
        this.timeSpan = moment(finish).diff(moment(start));
        this.weight = this.item.Item.Weight || 0;
    };
    Object.defineProperty(AgendaAttendant.prototype, "start", {
        get: function () {
            if (this.entity && this.entity.entityType.shortName === 'Service') {
                return moment(this.entity['StartBase']);
            }
            return moment(this.item.Start);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgendaAttendant.prototype, "finish", {
        get: function () {
            if (this.entity && this.entity.entityType.shortName === 'Service') {
                return moment(this.entity['FinishBase']);
            }
            return moment(this.item.Finish);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the appropriate collection of the given timeslot for this AgendaAvailability class.
     */
    AgendaAttendant.prototype.getCollectionOf = function (timeSlot) {
        return timeSlot.gridAttendants;
    };
    /**
     * Create a copy of this instance.
     */
    AgendaAttendant.prototype.makeCopy = function () {
        var copy = new AgendaAttendant(this.item);
        copy.covers = this.covers;
        copy.zIndex = this.zIndex;
        return copy;
    };
    return AgendaAttendant;
}(PlanItemWrapper));
export { AgendaAttendant };
